import React from 'react';
import {
  FaCalendarAlt,
  FaFlag,
  FaMapMarkerAlt,
  FaTrophy,
  FaUsers,
} from 'react-icons/fa';
import odinLogo from '../assets/ODIN_Logo_No_BG-01.png';
import './ReliabilityChampionshipPage.css';

const schedule = [
  {
    date: 'MAY 19',
    label: 'Welcome Reception',
    detail: 'An opening evening for industrial leaders, facility teams, contractors, sponsors, and invited guests.',
  },
  {
    date: 'MAY 20',
    label: 'Championship Tournament',
    detail: 'A full day of golf, competition, hospitality, and relationship-building across the reliability community.',
  },
  {
    date: 'MAY 21',
    label: 'Optional Fishing Experience',
    detail: 'An optional participant-funded outing for guests who would like to extend their time in Southwest Louisiana.',
  },
];

const audiences = [
  'Maintenance & Reliability Leaders',
  'Facility Engineering Teams',
  'Inspection & Integrity Professionals',
  'Industrial Service Contractors',
  'Manufacturers & Solution Providers',
  'Operations Leadership',
];

function ReliabilityChampionshipPage() {
  return (
    <main className="championship-page">
      <header className="championship-nav">
        <img src={odinLogo} alt="ODIN Asset Manager" />
        <div className="championship-nav-mark">
          <span>2027</span>
          <strong>RELIABILITY &amp; MAINTENANCE</strong>
        </div>
        <span className="championship-nav-status">PRIVATE EVENT PREVIEW</span>
      </header>

      <section className="championship-hero">
        <div className="championship-hero-grid" aria-hidden="true" />
        <div className="championship-hero-glow" aria-hidden="true" />
        <div className="championship-hero-copy">
          <span className="championship-kicker">ODIN ASSET MANAGER PRESENTS</span>
          <div className="championship-year">2027</div>
          <h1>Maintenance <em>&amp;</em><br />Reliability Championship</h1>
          <p>
            Where the people who keep industry running come together—for competition,
            connection, and a championship experience in Southwest Louisiana.
          </p>
          <div className="championship-hero-details">
            <span><FaCalendarAlt aria-hidden="true" /> May 19–21, 2027</span>
            <span><FaMapMarkerAlt aria-hidden="true" /> Lake Charles, Louisiana</span>
          </div>
          <div className="championship-tentative">DATES AND EVENT DETAILS ARE TENTATIVE</div>
        </div>

        <aside className="championship-scorecard" aria-label="Event overview">
          <div className="scorecard-top">
            <FaTrophy aria-hidden="true" />
            <div><span>THE CHAMPIONSHIP</span><strong>Industry meets on the course.</strong></div>
          </div>
          <dl>
            <div><dt>Format</dt><dd>Team Competition</dd></div>
            <div><dt>Audience</dt><dd>Industrial Professionals</dd></div>
            <div><dt>Experience</dt><dd>Golf · Reception · Networking</dd></div>
            <div><dt>Host City</dt><dd>Lake Charles, LA</dd></div>
          </dl>
          <p>Additional venue, team, sponsorship, and registration information will be released as planning is finalized.</p>
        </aside>
      </section>

      <section className="championship-intro">
        <span className="championship-section-label">MORE THAN A TOURNAMENT</span>
        <div>
          <h2>Built for the community behind industrial reliability.</h2>
          <p>
            The Maintenance and Reliability Championship brings facility decision-makers,
            contractors, inspectors, manufacturers, and solution providers together in an
            environment designed for real conversations and lasting professional relationships.
          </p>
        </div>
      </section>

      <section className="championship-pillars">
        <article>
          <span>01</span>
          <FaFlag aria-hidden="true" />
          <h3>Compete</h3>
          <p>Represent your company or facility alongside teams from across the industrial community.</p>
        </article>
        <article>
          <span>02</span>
          <FaUsers aria-hidden="true" />
          <h3>Connect</h3>
          <p>Build relationships with the professionals responsible for keeping critical operations safe and available.</p>
        </article>
        <article>
          <span>03</span>
          <FaTrophy aria-hidden="true" />
          <h3>Champion Reliability</h3>
          <p>Recognize the people, partnerships, and expertise that make world-class maintenance programs possible.</p>
        </article>
      </section>

      <section className="championship-schedule">
        <div className="championship-section-heading">
          <span className="championship-section-label">TENTATIVE EVENT SCHEDULE</span>
          <h2>Three days in Southwest Louisiana.</h2>
        </div>
        <div className="schedule-list">
          {schedule.map((item, index) => (
            <article key={item.date}>
              <div className="schedule-index">0{index + 1}</div>
              <div className="schedule-date"><strong>{item.date}</strong><span>2027</span></div>
              <div className="schedule-copy"><h3>{item.label}</h3><p>{item.detail}</p></div>
            </article>
          ))}
        </div>
      </section>

      <section className="championship-community">
        <div>
          <span className="championship-section-label">WHO IT BRINGS TOGETHER</span>
          <h2>One event. The full reliability ecosystem.</h2>
          <p>
            Created for the facility teams and trusted partners who plan, inspect, repair,
            protect, and improve critical industrial assets.
          </p>
        </div>
        <div className="community-list">
          {audiences.map((audience) => <span key={audience}>{audience}</span>)}
        </div>
      </section>

      <section className="championship-sponsor">
        <div>
          <span className="championship-section-label">PARTICIPATION &amp; SPONSORSHIP</span>
          <h2>Put your organization at the center of the reliability community.</h2>
          <p>
            Team registration, reception participation, facility-team sponsorships, and event
            partnership opportunities will be announced with the official championship packet.
          </p>
        </div>
        <div className="championship-contact-note">
          Participation details will be included in the official championship packet.
        </div>
      </section>

      <footer className="championship-footer">
        <img src={odinLogo} alt="ODIN Asset Manager" />
        <div><strong>Maintenance &amp; Reliability Championship</strong><span>Lake Charles, Louisiana · 2027</span></div>
        <p>Presented by ODIN Asset Manager</p>
      </footer>
    </main>
  );
}

export default ReliabilityChampionshipPage;
